import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiSelect = styled('div')(
  () => css`
    &.error {
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid #d32f2f !important;
      }
    }

    .MuiFormHelperText-root {
      color: #d32f2f;
      margin: 3px 5px 0;
      display: block;
      font-size: 0.625rem;
      text-align: right;
      font-family: inherit !important;
    }
  `
);
